<template>
	<div class="linear-chart-container">
		<div class="linear-chart" v-for="(item, i) in data" :key="i">
			<div class="linear-chart-lines">
			</div>
			<span class="linear-chart-badge">{{item.data.title}}</span>
			<div class="linear-chart-fullness" :style="`background-color: ${item.color}; width: ${item.data.mark * 10}%;`"></div>
		</div>
	</div>
</template>
<style lang="css">
	.linear-chart {
		overflow: hidden;
		background-color: #EFEFFF;
		border-radius: 4px;
		position: relative;
		padding: 5px 4px;
		min-height: 46px;
		margin-bottom: 1px;
	}
	.linear-chart-lines {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-size: 10% 47px;
		background-image: linear-gradient(to left, rgba(39, 44, 91, .1) 1px, transparent 1px);
		z-index: 1;
	}
	.linear-chart-fullness {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		display: block;
		z-index: 0;
	}
	.linear-chart-badge {
		font-size: 14px;
		line-height: 18px;
		display: inline-block;
		background: #FFFFFF;
		border: 1px solid #404044;
		border-radius: 4px;
		padding: 2px 8px;
		position: relative;
		z-index: 2;
	}
</style>
<script>
	export default {
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				},
				required: true,
			}
		},
	}
</script>
